import React from "react";
import * as PropTypes from "prop-types";
import { Link } from "gatsby-plugin-intl";
import { Tag } from "@chakra-ui/core";
import CategoryType from "./categoryType";
import { getAttributeTranslated } from "../../util/entities";

const backgroundColors = [
  "green",
  "orange",
  "teal",
  "purple",
  "blue",
  "gray",
  "red",
  "yellow",
];

const getColor = (color, index) => {
  if (color) {
    return color;
  }
  if (typeof index === 'number') {
    return backgroundColors[(index % backgroundColors.length)];
  }
  return backgroundColors[0];
};

const CategoryTag = ({
  category, locale, color, index, listing,
}) => {
  const uri = (category.fields && category.fields.slug) || "#";
  const otherProps = listing ? {
    variantColor: "gray",
    fontSize: "0.6rem",
    mb: .5,
  } : {
    my: 1,
    fontSize: "0.8rem",
    variantColor: getColor(color, index),
  };
  return (
    <Link to={uri}>
      <Tag
        minHeight="1rem"
        mr={1}
        rounded="full"
        {...otherProps}
      >
        {getAttributeTranslated(category, 'name', locale)}
      </Tag>
    </Link>
  );
}

CategoryTag.propTypes = {
  category: CategoryType.isRequired,
  locale: PropTypes.string,
  color: PropTypes.string,
  index: PropTypes.number,
  listing: PropTypes.bool,
};

CategoryTag.defaultProps = {
  locale: "es",
  color: null,
  index: 0,
  listing: false,
};

export default CategoryTag;
